<template>
  <div id="redNotification">
    <slot />
  </div>
</template>

<style scoped lang="scss">
#redNotification {
  position: fixed;
  bottom: 24px;
  inset-inline-end: 24px;
  z-index: $z-index-notifications;
  margin: 0;
  border-radius: $border-radius-l;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 12px;

  @include themed() {
    background: t($bg-alt);
    border: 1px solid t($grey-15);
    box-shadow: $tooltip;
  }

  a {
    text-decoration: underline;
    display: inline-block;
    padding-inline-start: 4px;
    cursor: pointer;
  }

  a,
  span {
    @include themed() {
      color: t($bg-alt);
    }
  }
}
</style>
